/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Reply_Incomplete_LabelInputs */



/**
* | output |
* | --- |
* | "Reply Incomplete" |
*
* @param {Style_Guide_Manager_Reply_Incomplete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_reply_incomplete_label = /** @type {((inputs?: Style_Guide_Manager_Reply_Incomplete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Reply_Incomplete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reponse incomplete")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort unvollständig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risposta incompleta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ответ неполный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Respuesta incompleta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复未完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信が未完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर अधूरा है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resposta incompleta")
	return /** @type {LocalizedString} */ ("Reply Incomplete")
});